import React from 'react';
import { FormControlLabel, Grid, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../utils/GeneralUtils';
import { OrderPageTypography } from '../themedComponents/OrderPageTypography';
import { OrderPageCheckbox } from '../themedComponents/OrderPageCheckbox';
import { useOrderPage } from '../orderPageContext/useOrderPage';

export const DisclaimersStep = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const language = useLanguage();
  const { orderPageState, onDisclaimersChange, disclaimersAccepted, disclaimersError } = useOrderPage();
  const { orderPage } = orderPageState;
  const rawDisclaimersContent = orderPage.disclaimers?.[language];
  const disclaimersContent = rawDisclaimersContent
    ? rawDisclaimersContent.replace(/{duration}/g, Math.round(orderPageState.details.duration / 60).toString())
    : undefined;

  if (!disclaimersContent) {
    return null;
  }

  return (
    <Grid container flexDirection="column" gap={3} mt={2}>
      <OrderPageTypography variant="h3">{t('order_page.disclaimers_title')}</OrderPageTypography>

      <Grid
        container
        sx={{
          maxHeight: '400px',
          overflow: 'auto',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          padding: 2,
          backgroundColor: theme.customTheme.palette.background,
        }}>
        <div
          dangerouslySetInnerHTML={{ __html: disclaimersContent }}
          style={{
            fontFamily: theme.customTheme.typography.fontFamily,
            width: '100%',
            lineHeight: '1.6',
            fontSize: '14px',
            color: theme.customTheme.palette.text.primary,
          }}
        />
      </Grid>

      <Grid container flexDirection="column">
        <FormControlLabel
          control={
            <OrderPageCheckbox
              checked={disclaimersAccepted}
              onChange={(event) => onDisclaimersChange(event.target.checked)}
              size="medium"
            />
          }
          label={<OrderPageTypography variant="body1">{t('order_page.disclaimers_acceptance')}</OrderPageTypography>}
        />
        {disclaimersError && !disclaimersAccepted && (
          <Grid item color={theme.customTheme.palette.error} mt={-1}>
            <Typography fontSize="12px">{t('order_page.disclaimers_required')}</Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default DisclaimersStep;
